import { render, staticRenderFns } from "./ConfirmDialogUserCenter.vue?vue&type=template&id=1e755b65&scoped=true"
import script from "./ConfirmDialogUserCenter.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogUserCenter.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDialogUserCenter.vue?vue&type=style&index=0&id=1e755b65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e755b65",
  null
  
)

export default component.exports